/**
 * Servicio de heartbeat: envía al backend cada 45s un latido con el estado
 * del player (versión de contenido, errores, espacio libre, etc.).
 */

import type { PlayerSocket } from './socket';

const HEARTBEAT_INTERVAL_MS = 45_000;

export function startHeartbeat(socket: PlayerSocket, getState: () => {
  contentVersion: string | null;
  errors: string[];
}) {
  let timer: ReturnType<typeof setInterval> | null = null;
  let startTime = Date.now();

  function tick() {
    const state = getState();
    socket.emit('player:heartbeat', {
      contentVersion: state.contentVersion,
      tizenVersion: detectTizenVersion(),
      storageFreeBytes: estimateStorageFreeBytes(),
      uptimeSeconds: Math.floor((Date.now() - startTime) / 1000),
      errors: state.errors,
    });
  }

  // Primer heartbeat inmediato, luego cada 45s
  tick();
  timer = setInterval(tick, HEARTBEAT_INTERVAL_MS);

  return () => {
    if (timer) clearInterval(timer);
  };
}

/**
 * Tizen expone el user agent con string característico.
 * En no-Tizen devuelve 'browser'.
 */
function detectTizenVersion(): string {
  const ua = navigator.userAgent;
  const match = /Tizen\s+(\d+\.\d+)/.exec(ua);
  return match?.[1] ?? 'browser';
}

/**
 * Estimación del espacio libre via navigator.storage (cuando esté disponible).
 * En Tizen puede no estarlo — devolvemos null.
 */
function estimateStorageFreeBytes(): number | null {
  if (typeof navigator !== 'undefined' && 'storage' in navigator && navigator.storage?.estimate) {
    // estimate() es asíncrono pero acá lo querríamos sync; devolvemos null y el campo se omite
    // (TODO: cachear el último valor estimado en una var module-level)
  }
  return null;
}
